# Current Order View
SupportDealSummaryView = require('./deal_summary_view')
SupportOrderSummaryView = require('./order_summary_view')
SupportOrderActionsView = require('./order_actions_view')
SupportServiceActionMainView = require('./service_action_main_view')
SupportExternalDealNotesView = require('./external_deal_notes')
Backbone = require 'backbone'
Backbone.$ = $

class SupportCurrentOrderView extends Backbone.View
  className: 'row order-details'

  initialize: (options) ->
    @I18nScope = 'modules.support'
    @currentOrder =  Groupon.Support.currentOrder
    @options = options || {}

  renderSubViews: ->
    @renderExternalDealNotes()
    @renderDealSummary()
    @renderOrderSummary()
    @renderOrderActions()

  render: ->
    @renderSubViews()
    @layoutView()

  layoutView: ->
    @dealSummary.$el.addClass('five columns')
    $('.deal-image', @dealSummary.$el).addClass('five columns')
    $('.deal-info', @dealSummary.$el).addClass('seven columns')
    @orderSummary.$el.addClass('seven columns')
    unless @options.hideSelfServiceActions
      @serviceActionMain.$el.addClass('cb')
      @orderSummary.$el.append(@serviceActionMain.el)
    @$el.append(@dealSummary.el)
    @$el.append(@orderSummary.el)

  renderDealSummary: ->
    @createDealSummaryView()
    @dealSummary.render()

  renderOrderSummary: ->
    @createOrderSummaryView()
    @orderSummary.render()

  renderOrderActions: ->
    @createServiceActionView()
    unless @options.hideSelfServiceActions
      @serviceActionMain.render()

  renderExternalDealNotes:(contentWrapper) ->
    @externalDealNotes = new SupportExternalDealNotesView()
    if not @options.hideExternalDealNotes && @externalDealNotes.externalDealNotesPresent()
      @externalDealNotes.render()
      @$el.append(@externalDealNotes.el)

  createDealSummaryView: ->
    @dealSummary = new SupportDealSummaryView()

  createOrderSummaryView: ->
    @orderSummary = new SupportOrderSummaryView()

  createServiceActionView: ->
    @serviceActionMain = new SupportServiceActionMainView({})

module.exports = SupportCurrentOrderView
